import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConverterService, InterceptorUtil, LoggerService, OccEndpointsService, tryNormalizeHttpError, USE_CLIENT_TOKEN, User } from '@spartacus/core';
import { USER_PROFILE_NORMALIZER, USER_SIGN_UP_SERIALIZER } from '@spartacus/user/profile/core';
import { UserSignUp } from '@spartacus/user/profile/root';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CustomDocumentIdentifierValidatorAdapter } from '../conectors/custom-document-identifier-validator.adapters';

@Injectable()
export class CustomOccDocumentIdentifierValidatorAdapter implements CustomDocumentIdentifierValidatorAdapter {
  constructor(protected http: HttpClient, protected occEndpoints: OccEndpointsService, protected converter: ConverterService) {}
  protected logger = inject(LoggerService);
  public documentIdentifierValidator(user: UserSignUp): Observable<User> {
    const url: string = this.occEndpoints.buildUrl('documentIdentifierValidator');
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    user = this.converter.convert(user, USER_SIGN_UP_SERIALIZER);

    return this.http.post<User>(url, user, { headers }).pipe(
      catchError((error) => throwError(tryNormalizeHttpError(error, this.logger))),
      this.converter.pipeable(USER_PROFILE_NORMALIZER)
    );
  }
}
